'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterKey", "SelectComponent"];
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import UILink from 'UIComponents/link/UILink';
import { getCanonicalAppContext } from '../../selectors/app';
import { getServices } from '../../slices/serviceCatalogSlice';
import { getMultiSelectStorefrontFilters } from '../../slices/storefrontFiltersSlice';
import { fromFilterStateToLocation } from '../../utils/storefrontFilters';
import { getFullLocationUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const BasePrerenderFilter = props => {
  const {
      filterKey,
      SelectComponent
    } = props,
    passThroughProps = _objectWithoutPropertiesLoose(props, _excluded);
  const filters = useSelector(getMultiSelectStorefrontFilters);
  const catalogServices = useSelector(getServices);
  const canonicalAppContext = useSelector(getCanonicalAppContext);
  const getFilterLink = useCallback(value => {
    const filtersLocation = fromFilterStateToLocation(Object.assign({}, filters, {
      [filterKey]: [value]
    }), catalogServices);
    return getFullLocationUrl(filtersLocation, canonicalAppContext);
  }, [canonicalAppContext, catalogServices, filterKey, filters]);
  const OptionRenderer = useCallback(({
    children,
    option
  }) => /*#__PURE__*/_jsx(UILink, {
    href: getFilterLink(option.value),
    use: "unstyled",
    children: children
  }), [getFilterLink]);
  return /*#__PURE__*/_jsx(SelectComponent, Object.assign({
    defaultOpen: true,
    optionComponent: OptionRenderer
  }, passThroughProps));
};
export default BasePrerenderFilter;